import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { messageService } from './messages/message.module';
import { MessageService } from './messages/message.service';
import { EventService } from './event.service';
import { EmailSettings } from 'app/main/content/system-maintenance/system-settings/system-settings.component';
import { map, take } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { DVLASettings } from './default-data.service';


@Injectable()
export class SystemSettingsService {

  constructor(
    private http: HttpClient,
    private eventService: EventService,
  ) {    
  }

  public enableMessages: boolean=true;

  updateIntegerSetting(settingName: string, settingValue: number)
  {    
    return this.updateSetting(new SystemSetting(settingName, settingValue));
  }

  updateStringSetting(settingName: string, settingValue: string)
  {    
    return this.updateSetting(new SystemSetting(settingName, null, null, null, settingValue));
  }

  updateDateTimeSetting(settingName: string, settingValue: Date)
  {    
    return this.updateSetting(new SystemSetting(settingName, null, settingValue));
  }

  updateBooleanSetting(settingName: string, settingValue: boolean)
  {    
    return this.updateSetting(new SystemSetting(settingName, null, null, settingValue));
  }

  updateSetting(systemSetting: SystemSetting)
  {
      const url = '/api/Settings/system';
      this.http.post(url, systemSetting).pipe(take(1)).subscribe( (result) => {          
          // console.log(result);
          messageService.success('Changes to the system settings have been saved successfully.', 'System Settings saved');
      }, (error) => {
        console.log(error);        
        messageService.error(`The changes to the system settings have not been saved. `, 'Error Saving System Settings', error);
      });
      
      // notify subscribers settings have changed
      this.eventService.updateSettings(systemSetting);
  }  

  updateDVLASetting(dvlaSettings: DVLASettings)
  {
      const url = '/api/Settings/dvlaSettings';
      this.http.post(url, dvlaSettings).pipe(take(1)).subscribe( (result) => {
          messageService.success('Changes to the DVLA Settings have been saved successfully.', 'DVLA Settings saved');
      }, (error) => {
        console.log(error);        
        messageService.error(`The changes to the DVLA Settings have not been saved. `, 'Error Saving DVLA Settings', error);
      });
      
      // notify subscribers settings have changed
      // this.eventService.updateSettings(systemSetting);
  }  

  deleteSMTPData(): Observable<boolean>{
    const url = 'api/Settings/deleteSMTP';
    return this.http.post(url,'').pipe(map((result) =>{
      if(result == true){
        messageService.success("Server Details have been deleted");
        return true;
      }
      if(result == false){
        messageService.error(`The changes to the system settings have not been saved. `, 'Error Saving System Settings');
        return false;
      }
    }, (error)=>{
      console.log(error);        
      messageService.error(`The changes to the system settings have not been saved. `, 'Error Saving System Settings', error);
      return false;
    }));
  }


  dataExtract():Observable<any>{

    const url = "/api/DataExtract/callExtractMethod";
    return this.http.get(url,{headers: new HttpHeaders({ 'Content-Type': 'application/json', 'timeout': '28800000'  })}).pipe(map((result) =>{//returning the observable so we can return the results
      return result;

    }, (error)=>{
      console.log(error);
      messageService.error("Something has occured when extracting data. Please try again")
    }))

  }



  sendValidationEmail(testDetails: EmailSettings): Observable<boolean>{
      const url = "/api/Settings/validateSMTP";
      return this.http.post(url,testDetails).pipe(map((result) =>{
        if(result == true){

          this.updateStringSetting('ServerName', testDetails.SMTPServer);

          this.updateStringSetting('ServerUsername', testDetails.userName);

          this.updateStringSetting('ServerPassword', testDetails.password);

          this.updateIntegerSetting('ServerPort', testDetails.port);

          this.updateStringSetting('ServerFromAddress', testDetails.fromAddress);

          this.updateStringSetting('ServerToAddress', testDetails.toAddress);

          messageService.success("Server Details have been added successfully");

          return true;
        }else{
          messageService.error("Server Details cannot be connected to.")
          return false;
        }
      }, (error) =>{
        console.log(error);
        messageService.error("Server Details cannot be connected to.")
        return false;
      }
      ));
    }
  }


// tslint:disable-next-line:max-classes-per-file
export class SystemSetting
{
    settingName: string;
    integerSetting: number;
    dateTimeSetting: Date;
    booleanSetting: boolean;
    stringSetting: string;    
    doubleSetting: number;

    constructor(settingName: string, intSetting?: number, dateTimeSetting?: Date, booleanSetting?: boolean, stringSetting?: string) {
        this.settingName = settingName;
        if (intSetting || intSetting === 0) 
        {
            this.integerSetting = intSetting;
        }
        if (dateTimeSetting)
        {
            this.dateTimeSetting = dateTimeSetting;
        }
        if (booleanSetting || booleanSetting === false)
        {
            this.booleanSetting = booleanSetting;
        }
        if (stringSetting || stringSetting === '')
        {
            this.stringSetting = stringSetting;
        }
    }
}
